import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table__card"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "table__card__item__value" }

import { ref, onMounted, computed } from 'vue';
import { BaseTabs, BaseTabPane } from 'xrk-components';

import { summarizeTheInvoiceInformation } from '@V/invoice/src/data-source/apis';
import { formatter } from '@/utils';
import { useRouteMeta } from '@hooks/common';
import { TABS } from '@V/invoice/src/constants';
import { RouteQuery } from '@V/invoice/src/types';
import { useRoute } from 'vue-router';
import appStore from '@/store';
import { storeToRefs } from 'pinia';
import { IS_PLATFORM_TYPE_1 } from '@/config';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-main',
  setup(__props) {

const route = useRoute();
const routeMeta = useRouteMeta();
const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

const routeQuery = route.query as RouteQuery;
const isAsp = [2].includes(+routeMeta.functionCode);
const isSupplier = [3].includes(+routeMeta.functionCode);
const isGy = [1].includes(+routeMeta.functionCode);

const tab = ref();
const statistics = ref({
  amountToBeInvoiced: {
    label: '待开票金额',
    value: '',
    key: 'amountToBeInvoiced'
  },
  amountToBeInvoicedNum: {
    label: '待开票订单笔数',
    value: '',
    key: 'amountToBeInvoicedNum'
  },
  monthlyInvoicingAmountToBeProcessed: {
    label: '月度待开票金额',
    value: '',
    key: 'monthlyInvoicingAmountToBeProcessed'
  },
  inTheProcessOfInvoicing: {
    label: '开票中',
    value: '',
    key: 'inTheProcessOfInvoicing'
  },
  annualCumulativeAmount: {
    label: '当年累计开票金额',
    value: '',
    key: 'annualCumulativeAmount'
  },
  annualCumulativeNum: {
    label: '当年累计开票数',
    value: '',
    key: 'annualCumulativeNum'
  },
  lastMonthAmount: {
    label: '上一个月度累计开票金额',
    value: '',
    key: 'lastMonthAmount'
  },
  lastMonthNum: {
    label: '上一个月度累计开票笔数',
    value: '',
    key: 'lastMonthNum'
  },
  redInkInvoiceAmount: {
    label: '红冲发票数',
    value: '',
    key: 'redInkInvoiceAmount'
  },
  redInkInvoiceNum: {
    label: '红冲发票金额',
    value: '',
    key: 'redInkInvoiceNum'
  }
});

const curCmopt = computed(() => {
  return TABS[tab.value]?.cmpt;
});
/* 对应角色设置tab */
const tabs = computed(() => {
  if (isAsp) {
    // 独立项目也没有个体发票上传
    if (userInfo.value.isBaseAsp === 1 && IS_PLATFORM_TYPE_1) {
      return [TABS[1], TABS[2], TABS[4], TABS[3]];
    }
    return [TABS[1], TABS[2], TABS[3]];
  }
  if (isSupplier) {
    return [TABS[1], TABS[2]];
  }
  if (isGy) {
    return [TABS[3]];
  }
  return [];
});

onMounted(async () => {
  tab.value = +routeQuery.tab ? +routeQuery.tab : tabs.value[0].value;
  if (!isGy) {
    const { data } = await summarizeTheInvoiceInformation();
    Object.keys(statistics.value).forEach(key => {
      if (
        [
          'amountToBeInvoiced',
          'monthlyInvoicingAmountToBeProcessed',
          'annualCumulativeAmount',
          'lastMonthAmount',
          'redInkInvoiceAmount'
        ].includes(key)
      ) {
        statistics.value[key].value = formatter.fen2yuan(data[key]);
      } else {
        statistics.value[key].value = data[key];
      }
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(isGy))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statistics.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "table__card__item",
              key: item.value
            }, [
              _createElementVNode("p", {
                class: "table__card__item__label",
                title: item.label
              }, _toDisplayString(item.label), 9, _hoisted_2),
              _createElementVNode("p", _hoisted_3, _toDisplayString(item.value), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (tabs.value.length > 1)
      ? (_openBlock(), _createBlock(_unref(BaseTabs), {
          key: 1,
          style: {"margin":"10px 0"},
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (item) => {
              return (_openBlock(), _createBlock(_unref(BaseTabPane), {
                label: item.label,
                name: item.value,
                key: item.value
              }, null, 8, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent(curCmopt.value)))
  ]))
}
}

})